import { useQuery } from "@tanstack/react-query";
import type { WeeklyDigest } from "@money/shared";
import { apiFetch } from "./client";

export function useDigest() {
  return useQuery({
    queryKey: ["digest"] as const,
    queryFn: () => apiFetch<WeeklyDigest>("/digest"),
    staleTime: 60_000,
  });
}
